import { cn } from "@/lib/utils";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface SliderEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: number | null;
    percentageValue: number;
}

export function SliderEntryValue({ value, inputLabel, percentageValue, size, ...props }: SliderEntryValueProps) {
    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} {...props}>
            <p
                className={cn(
                    "text-xl inline-flex items-center justify-center rounded-md border border-slate-200 bg-white px-4 py-1 mb-2"
                )}
            >
                {String(value)}
            </p>
            <div
                className={cn(
                    "relative bg-slate-100 rounded-full h-2 w-full",
                    size === "sm" && "h-1.5",
                    size === "lg" && "h-3"
                )}
            >
                <div
                    style={{
                        width: `${percentageValue ? percentageValue : 0}%`,
                    }}
                    className="top-0 left-0 absolute bg-indigo-600 rounded-full h-full"
                />
            </div>
        </BaseEntryValue>
    );
}
